<div
    class="flex h-full flex-col justify-between md:flex-row md:overflow-hidden">
    <div
        class="aspect-h-1 aspect-w-3 overflow-hidden md:aspect-none md:order-2 md:h-full md:w-[40vh]">
        <app-lazy-picture
            class="block"
            [lazy]="true"
            [configurations]="featuredImageConfiguration"
            [preload]="false"></app-lazy-picture>
    </div>
    <div
        class="flex w-full justify-center p-8 px-8 md:order-1 md:overflow-y-scroll md:px-12">
        <div class="max-w-md">
            <h2 class="font-medium">
                @if (modalData.trip.enquireFormHeading) {
                    {{ modalData.trip.enquireFormHeading }}
                } @else {
                    Ready for Your Next Adventure?
                }
            </h2>
            <p class="text-sm text-deemphasized">
                @if (modalData.trip.enquireFormDescription) {
                    {{ modalData.trip.enquireFormDescription }}
                } @else {
                    We'll send you a personalised itinerary and connect you with
                    one of our travel experts!
                }
            </p>
            <app-form-dynamic-with-config
                [formSchema]="formSchema"
                (onSubmit)="
                    submitPrimaryForm($event)
                "></app-form-dynamic-with-config>
        </div>
    </div>
</div>
